<template>
  <div class="swiper-button">
    <div class="verticallyCenter">
      <cx-check-box :value.sync="showButton">显示切换按钮</cx-check-box>
      <i class="tips-btn icon-portal-info2" @click="clickDialog()"></i>
    </div>
    <!-- <div v-show="showButton" class="setting-item clearFloat mt16">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title" :style="{ color: 'var(--textColor)' }"> &nbsp;&nbsp;按钮样式 </template>
          <icon-select class="mt16" :selectedIcon.sync="swiperButtnIconClassName"></icon-select>
        </el-collapse-item>
      </el-collapse>
      <slider-and-input
        class="mt16"
        :value.sync="buttonIconSize"
        title="按钮大小"
        :sliderMax="100"
        :sliderMin="1"
        suffix="px"
      />
      <color-picker class="mt16" :color.sync="buttonIconColor" title="按钮颜色" />
      <el-checkbox class="mt16" v-model="buttonIconShowBackGround">显示按钮背景</el-checkbox>
      <div v-show="buttonIconShowBackGround">
        <color-picker class="mt16" :color.sync="buttonIconBackgroundColor" title="背景色" />
        <double-input
          title="尺寸"
          class="mt16"
          placeHolderText="必填"
          :value1.sync="buttonIconBackgroundWidth"
          :value2.sync="buttonIconBackgroundHeight"
          :inputSuffixs="['宽', '高']"
        />
        <slider-and-input
          class="mt16"
          :value.sync="buttonIconBackGroundBorderRadius"
          title="圆角"
          :sliderMax="20"
          :sliderMin="1"
          suffix="px"
        />

        <el-checkbox v-model="buttonIconCustomTop">自定义按钮位置</el-checkbox>
        <div v-show="buttonIconCustomTop">
          <slider-and-input
            class="mt16"
            :value.sync="buttonIconTop"
            title="高度"
            :sliderMax="800"
            :sliderMin="-200"
            suffix="px"
          />
          <slider-and-input
            class="mt16"
            :value.sync="buttonIconPadding"
            title="内边距"
            :sliderMax="200"
            :sliderMin="-200"
            suffix="px"
          />
        </div>
      </div>
    </div> -->
    <div v-show="showButton" class="setting-item clearFloat">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title">切换图标</template>
          <img-icon-upload
            class="mt8"
            :imgSrc.sync="iconSrc"
            :iconType.sync="buttonIconType"
            :iconColor.sync="buttonIconColor"
            :showDel="false"
            :resInfo.sync="iconResInfo"
            size="small"
          />
          <div class="verticallyCenter mt12">
            <span class="mr16">颜色</span>
            <cx-color-picker
              class="flex1"
              :isThemeColor.sync="iconColorIsThemeColor"
              :colorArr.sync="buttonIconColor"
              >
            </cx-color-picker>
          </div>
          <slider-and-input
            class="mt12"
            :value.sync="buttonIconSize"
            title="大小"
            :sliderMax="100"
            :sliderMin="1"
            suffix="px"
          />
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">背景</template>
          <div class="verticallyCenter mt12">
            <span class="mr16">背景色</span>
            <cx-color-picker
              class="flex1 lableWidth3"
              :isThemeColor.sync="iconBgIsThemeColor"
              :colorArr.sync="buttonIconBackgroundColor"
              >
            </cx-color-picker>
          </div>
          <div class="verticallyCenter mt12">
            <div class="mr16" style="width: 40px">尺寸</div>
            <div class="flex1 verticallyCenter cx_style">
              <el-input class="mr12" type="number" v-inputHandle="{ this1, type: 'buttonIconBackgroundWidth' }" v-model="buttonIconBackgroundWidth" @focus="getFocus($event)">
                <template slot="suffix">
                  <span class="suffix_text">宽</span>
                </template>
              </el-input>
              <el-input type="number" v-inputHandle="{ this1, type: 'buttonIconBackgroundHeight' }" v-model="buttonIconBackgroundHeight" @focus="getFocus($event)">
                <template slot="suffix">
                  <span class="suffix_text">高</span>
                </template>
              </el-input>
            </div>
          </div>
          <slider-and-input
            class="mt12 width40"
            :value.sync="buttonIconBackGroundBorderRadius"
            title="圆角"
            :sliderMax="99"
            :sliderMin="1"
            suffix="px"
          />
          <div class="mt12">
            <div class="checkbox_colorPicker_container">
              <span>阴影</span>
              <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
            </div>
            <box-shadow
              :boxShadowH.sync="buttonBoxShadowH"
              :boxShadowV.sync="buttonBoxShadowV"
              :boxShadowBlur.sync="buttonBoxShadowBlur"
              :boxShadowSpread.sync="buttonBoxShadowSpread"
              :boxShadowColor.sync="buttonBoxShadowColor"
            />
          </div>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template slot="title">位置</template>
          <div class="verticallyCenter mt12">
            <span class="mr16">位置</span>
            <div class="font-arrangement-btn height32 flex1">
              <span class="btn-active" :style="getTranslate"></span>
              <span
                v-for="(val, index) in positionList"
                :key="index"
                :class="buttonIconCustomTop == val.label ? 'select pd2' : 'pd2'"
                @click="changePosition(val.label)"
              >{{val.title}}</span>
            </div>
          </div>
          <slider-and-input
            v-if="!buttonIconCustomTop"
            class="mt12"
            :value.sync="buttonIconPadding"
            title="偏移"
            :sliderMax="800"
            :sliderMin="-200"
            suffix="px"
          />
          <div v-if="buttonIconCustomTop">
            <div class="mt12">左按钮位置</div>
            <div class="verticallyCenter mt16">
              <span class="mr16">横轴</span>
              <el-slider
                ref="elSlider"
                class="mr12 slider_size"
                :show-tooltip="false"
                v-model="leftButtonIconX"
                :min="0"
                :max="leftButtonIconXType === '%' ? 100: sliderMaxX"
              ></el-slider>
              <el-input class="input-size flex1" type="number" placeholder="-" v-model="leftButtonIconX" @focus="getFocus($event)">
                <template slot="suffix">
                  <el-dropdown trigger="click" @command="leftXTypeHandleCommand">
                  <span class="el-dropdown-link lineHeight32">
                    {{ leftButtonIconXType }}
                  </span>
                    <el-dropdown-menu slot="dropdown" class="dropdown-size">
                      <el-dropdown-item
                        v-for="(sizeType, index) in sizeTypes"
                        :command="sizeType.value"
                        :key="'sizeType_' + index"
                      ><span
                        class="selected-icon"
                        :class="leftButtonIconXType === sizeType.value ? 'icon-portal-check-small' : ''"
                      ></span
                      >{{ sizeType.label }}</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-input>
            </div>
            <slider-and-input
              class="mt8"
              :value.sync="leftButtonIconY"
              title="纵轴"
              :sliderMax="sliderMaxY"
              :sliderMin="0"
              suffix="px"
            />
            <div class="mt12">右按钮位置</div>
            <div class="verticallyCenter mt16">
              <span class="mr16">横轴</span>
              <el-slider
                ref="elSlider"
                class="mr12 slider_size"
                :show-tooltip="false"
                v-model="rightButtonIconX"
                :min="0"
                :max="rightButtonIconXType === '%' ? 100: sliderMaxX"
              ></el-slider>
              <el-input class="input-size flex1" type="number" placeholder="-" v-model="rightButtonIconX" @focus="getFocus($event)">
                <template slot="suffix">
                  <el-dropdown trigger="click" @command="rightXTypeHandleCommand">
                  <span class="el-dropdown-link lineHeight32">
                    {{ rightButtonIconXType }}
                  </span>
                    <el-dropdown-menu slot="dropdown" class="dropdown-size">
                      <el-dropdown-item
                        v-for="(sizeType, index) in sizeTypes"
                        :command="sizeType.value"
                        :key="'sizeType_' + index"
                      ><span
                        class="selected-icon"
                        :class="rightButtonIconXType === sizeType.value ? 'icon-portal-check-small' : ''"
                      ></span
                      >{{ sizeType.label }}</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-input>
            </div>
            <slider-and-input
              class="mt8"
              :value.sync="rightButtonIconY"
              title="纵轴"
              :sliderMax="sliderMaxY"
              :sliderMin="0"
              suffix="px"
            />
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import iconSelect from "./icon-select"
import { jsonCompressEncode } from "utils/jsonCompress"
import { decrypt } from "utils"
import { data_dictionary_map } from "root/static/dataDictionary"
import { withMethodsHistoryCombine } from "utils/revork"
export default withMethodsHistoryCombine({
  props: {
    options: {
      type: Object
    },
    ids: {
      type: Object
    }
  },
  components:{ iconSelect } ,
  data() {
    return {
      this1: this,
      iconData: [
        {
          name: "填充图标",
          data: [
            "icon-portal-circle-arrow-fill1",
            "icon-portal-circle-arrow-fill2",
            "icon-portal-circle-double-arrow-fill",
            "icon-portal-square-arrow-fill2"
          ]
        },
        {
          name: "线性图标",
          data: [
            "icon-portal-arrow1",
            "icon-portal-circle-arrow-empty1",
            "icon-portal-circle-arrow-empty2",
            "icon-portal-line-arrow4",
            "icon-portal-line-arrow3",
            "icon-portal-double-line-arrow",
            "icon-portal-line-arrow2",
            "icon-portal-line-arrow1"
          ]
        }
      ],
      swiperButton: [
        {
          type: 0,
          name: "无",
          buttonIcon: "button_none"
        },
        {
          type: 1,
          name: "样式1",
          buttonIcon: "button_style1"
        },
        {
          type: 2,
          name: "样式2",
          buttonIcon: "button_style2"
        },
        {
          type: 3,
          name: "样式3",
          buttonIcon: "button_style3"
        }
      ],
      activeNames: ["1","2","3"],
      positionList: [
        {
          label: 0,
          title: "左右两侧"
        },
        {
          label: 1,
          title: "自定义"
        },
      ],
      translate: 0,
      sliderMaxX: 1920,
      sliderMaxY: 800,
      sizeTypes: [
        {
          label: "px",
          value: "px"
        },
        {
          label: "%",
          value: "%"
        }
      ]
    }
  },
  computed: {
    swiperButtnIconClassName: {
      get() {
        return this.options.buttonIconClassName || ""
      },
      set(val) {
        this.$changeOptionsEV(val, "buttonIconClassName", false, null, this.getRectId)
      }
    },
    getRectId() {
      let ids = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id
      }
      if (this.ids.elementInAutoLayoutId !== undefined && this.ids.elementInAutoLayoutId !== null) {
        ids = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        }
      }
      return ids
    },
    buttonTop: {
      get() {
        return this.options && this.options.buttonTop ? this.options.buttonTop : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonTop", false, null, this.getRectId)
      }
    },
    buttonLeft: {
      get() {
        return this.options && this.options.buttonLeft ? this.options.buttonLeft : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonLeft", false, null, this.getRectId)
      }
    },
    swiperButtonType: {
      get() {
        return this.options.swiperButtonType
      },
      set(newVal) {
        console.log(this.getRectId)
        this.$changeOptionsEV(newVal, "swiperButtonType", false, null, this.getRectId)
      }
    },
    showButton: {
      get() {
        return this.options.showButton
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showButton", false, null, this.getRectId)
      }
    },
    buttonIconSize: {
      get() {
        return this.options.buttonIconSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonIconSize", false, null, this.getRectId)
      }
    },
    buttonIconColor: {
      get() {
        return this.options.buttonIconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonIconColor", false, null, this.getRectId)
      }
    },
    buttonIconShowBackGround: {
      get() {
        return this.options.buttonIconShowBackGround
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonIconShowBackGround", false, null, this.getRectId)
      }
    },
    buttonIconBackgroundColor: {
      get() {
        return this.options.buttonIconBackgroundColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonIconBackgroundColor", false, null, this.getRectId)
      }
    },
    buttonIconBackgroundWidth: {
      get() {
        return this.options.buttonIconBackgroundWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonIconBackgroundWidth", false, null, this.getRectId)
      }
    },
    buttonIconBackgroundHeight: {
      get() {
        return this.options.buttonIconBackgroundHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonIconBackgroundHeight", false, null, this.getRectId)
      }
    },
    buttonIconBackGroundBorderRadius: {
      get() {
        return this.options.buttonIconBackGroundBorderRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonIconBackGroundBorderRadius", false, null, this.getRectId)
      }
    },
    buttonIconCustomTop: {
      get() {
        let index = this.positionList.findIndex(item => item.label === this.options.buttonIconCustomTop)
        this.translate = 79.5*index < 0 ? 0 : 79.5*index
        return this.options.buttonIconCustomTop
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonIconCustomTop", false, null, this.getRectId)
      }
    },
    buttonIconPadding: {
      get() {
        return this.options.buttonIconPadding
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonIconPadding", false, null, this.getRectId)
      }
    },
    buttonIconTop: {
      get() {
        return this.options.buttonIconTop
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonIconTop", false, null, this.getRectId)
      }
    },
    iconSrc: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "iconSrc", "iconSrc", '')
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconSrc", false, null, this.getRectId)
      }
    },
    buttonIconType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "buttonIconType", "buttonIconType", 'icon')
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonIconType", false, null, this.getRectId)
      }
    },
    iconResInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "iconResInfo", "iconResInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconResInfo", false, null, this.getRectId)
      }
    },
    iconColorIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "iconColorIsThemeColor", "iconColorIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColorIsThemeColor", false, null, this.getRectId)
      }
    },
    iconBgIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "iconBgIsThemeColor", "iconBgIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconBgIsThemeColor", false, null, this.getRectId)
      }
    },
    getTranslate() {
      return {
        "transform": `translateX(${this.translate}px)`
      }
    },
    leftButtonIconX: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "leftButtonIconX", "leftButtonIconX", 20)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "leftButtonIconX", false, null, this.getRectId)
      }
    },
    leftButtonIconXType:{
      get() {
        return this.checkAndSetPrimaryVal(this.options, "leftButtonIconXType", "leftButtonIconXType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "leftButtonIconXType", false, null, this.getRectId)
      }
    },
    leftButtonIconY: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "leftButtonIconY", "leftButtonIconY", 60)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "leftButtonIconY", false, null, this.getRectId)
      }
    },
    rightButtonIconX: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "rightButtonIconX", "rightButtonIconX", 20)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "rightButtonIconX", false, null, this.getRectId)
      }
    },
    rightButtonIconXType:{
      get() {
        return this.checkAndSetPrimaryVal(this.options, "rightButtonIconXType", "rightButtonIconXType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "rightButtonIconXType", false, null, this.getRectId)
      }
    },
    rightButtonIconY: {
      get() {
        this.checkAndSetPrimaryVal(this.options, "rightButtonIconY", "rightButtonIconY", 60)
        return this.options.hasOwnProperty("rightButtonIconY") ? this.options.rightButtonIconY : 60
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "rightButtonIconY", false, null, this.getRectId)
      }
    },
    buttonBoxShadowColor: {
      get() {
        return this.options.hasOwnProperty("buttonBoxShadowColor") ? this.options.buttonBoxShadowColor : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonBoxShadowColor", false, null, this.getRectId)
      }
    },
    buttonBoxShadowH: {
      get() {
        return this.options.hasOwnProperty("buttonBoxShadowH") ? this.options.buttonBoxShadowH : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonBoxShadowH", false, null, this.getRectId)
      }
    },
    buttonBoxShadowV: {
      get() {
        return this.options.hasOwnProperty("buttonBoxShadowV") ? this.options.buttonBoxShadowV : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonBoxShadowV", false, null, this.getRectId)
      }
    },
    buttonBoxShadowBlur: {
      get() {
        return this.options.hasOwnProperty("buttonBoxShadowBlur") ? this.options.buttonBoxShadowBlur : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonBoxShadowBlur", false, null, this.getRectId)
      }
    },
    buttonBoxShadowSpread: {
      get() {
        return this.options.hasOwnProperty("buttonBoxShadowSpread") ? this.options.buttonBoxShadowSpread : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonBoxShadowSpread", false, null, this.getRectId)
      }
    },
  },
  methods: {
    changeIconClassName(name) {
      this.swiperButtnIconClassName = name
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    leftXTypeHandleCommand(val){
      if (this.leftButtonIconXType === val) {
        return
      }
      this.leftButtonIconXType = val
      this.leftButtonIconX = val === "%" ? 10 : 200
    },
    rightXTypeHandleCommand(val){
      if (this.rightButtonIconXType === val) {
        return
      }
      this.rightButtonIconXType = val
      this.rightButtonIconX = val === "%" ? 10 : 200
    },
    changePosition(val) {
      this.buttonIconCustomTop = val
    },
    addBoxshadow() {
      if (!Array.isArray(this.buttonBoxShadowH) || !Array.isArray(this.buttonBoxShadowColor)) {
        this.buttonBoxShadowH = [this.buttonBoxShadowH]
        this.buttonBoxShadowV = [this.buttonBoxShadowV]
        this.buttonBoxShadowBlur = [this.buttonBoxShadowBlur]
        this.buttonBoxShadowSpread = [this.buttonBoxShadowSpread]
        this.buttonBoxShadowColor = [this.buttonBoxShadowColor]
      }
      let buttonBoxShadowH = JSON.parse(JSON.stringify(this.buttonBoxShadowH))
      let buttonBoxShadowV = JSON.parse(JSON.stringify(this.buttonBoxShadowV))
      let buttonBoxShadowBlur = JSON.parse(JSON.stringify(this.buttonBoxShadowBlur))
      let buttonBoxShadowSpread = JSON.parse(JSON.stringify(this.buttonBoxShadowSpread))
      let buttonBoxShadowColor = JSON.parse(JSON.stringify(this.buttonBoxShadowColor))
      buttonBoxShadowH.push(0)
      buttonBoxShadowV.push(4)
      buttonBoxShadowBlur.push(4)
      buttonBoxShadowSpread.push(0)
      buttonBoxShadowColor.push("rgba(0,0,0,0.25)")
      this.buttonBoxShadowH = buttonBoxShadowH
      this.buttonBoxShadowV = buttonBoxShadowV
      this.buttonBoxShadowBlur = buttonBoxShadowBlur
      this.buttonBoxShadowSpread = buttonBoxShadowSpread
      this.buttonBoxShadowColor = buttonBoxShadowColor
    },
    clickDialog() {
      this.$emit("clickDialog")
    }
  },
  mounted() {
    this.sliderMaxY = this.$store.state[this.request_prefix].page.height
  }
})
</script>
<style scoped>
.fill_icon_box {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}
.swpier_botton_icon_box {
  width: 25%;
  text-align: center;
  font-size: 21px;
  padding: 9.5px;
}

.swpier_botton_icon::before {
  color: var(--color);
}
.swpier_botton_icon:hover {
  cursor: pointer;
  padding: 9.5px;
  border: 1px solid var(--themeColor);
  border-radius: 4px;
}
.active_swiper_button {
  padding: 9.5px;
  border: 1px solid var(--themeColor);
  border-radius: 4px;
}
.swiper-button .setting-item ::v-deep .el-collapse-item {
  background-color: transparent !important;
}
.toolbar .el-tabs .swiper-button .setting-item ::v-deep .el-collapse-item__header{
  height: 24px;
  padding-left: 18px !important;
  background: transparent !important;
  font-weight: 400;
  margin-top: 12px;
}
.swiper-button ::v-deep .el-collapse-item__wrap .el-collapse-item__content {
  padding-left: 18px !important;
}
.swiper-button .setting-item ::v-deep .el-collapse-item__header .el-collapse-item__arrow {
  left: 0 !important;
}
.width40 ::v-deep .flex_box .fs14.mr16{
  width: 40px;
}
.width40 ::v-deep .flex_box .el-input,
::v-deep .slider_and_input .el-input{
  width: 72px !important;
}
.font-arrangement-btn .btn-active {
  width: calc((100% - 6px) / 2);
}
.font-arrangement-btn.height32 span {
  font-size: 18px;
  height: 26px;
  line-height: 26px;
  font-size: 13px;
}
.font-arrangement-btn.height32 span i {
  line-height: 26px;
}
.height32 {
  height: 32px;
}
.lableWidth3{
  width: calc(100% - 60px);
}
.lineHeight32 {
  display: inline-block;
  line-height: 32px;
}
.color000 {
  color: var(--text);
}
::v-deep .el-dropdown-link {
  color: var(--subTextColor) !important;
}
::v-deep .input-size .el-input__suffix {
  right: 4px;
}
::v-deep .input-size .el-dropdown-link {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 3px;
  margin: 4px 0;
}
::v-deep .input-size .el-dropdown-link:hover {
  background: var(--paddingIconHoverColor);
}
.selected-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  font-size: 16px;
  color: var(--themeColor);
  transform: translateY(-50%);
}
.dropdown-size {
  margin-top: -32px;
}

.dropdown-size li {
  position: relative;
  width: 90px;
  padding-left: 36px;
}
.el-dropdown-menu__item {
  color: var(--textColor);
}
.slider_size{
  width: 82px;
}
</style>